import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-userT",
  "use": "icon-userT-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"icon-userT\"><defs><style>#icon-userT .cls-1{fill:#005faf;}</style></defs><title>画板 1</title><g id=\"icon-userT_未标题-1.psd\"><path class=\"cls-1\" d=\"M200,222.37c-57.7,0-104.65-47.14-104.65-105.08S142.3,12.22,200,12.22,304.65,59.35,304.65,117.29,257.7,222.37,200,222.37Zm0-183c-42.75,0-77.53,35-77.53,78s34.78,78,77.53,78,77.53-35,77.53-78S242.75,39.33,200,39.33Z\" /><path class=\"cls-1\" d=\"M348.08,388a13.55,13.55,0,0,1-13.56-13.56c0-74.24-60.35-134.64-134.52-134.64S65.48,300.2,65.48,374.44a13.56,13.56,0,1,1-27.12,0c0-89.19,72.51-161.75,161.64-161.75s161.64,72.56,161.64,161.75A13.56,13.56,0,0,1,348.08,388Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/userT.svg
// module id = NcoZ
// module chunks = 32